/* Lukante theme JS */
jQuery(document).ready(function () {
    
    jQuery(window).on("scroll", function () {
        if (jQuery(window).scrollTop() > 1) {
            jQuery("#main-nav").addClass("active-header");

         } else {
            //remove the background property so it comes transparent again (defined in your css)
            jQuery("#main-nav").removeClass("active-header");
        }
    });

});

document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("imgModal");
    const modalImg = document.getElementById("imgModalContent");
    const closeBtn = document.querySelector(".img-modal__close");

    document.querySelectorAll(".btn--portfolio").forEach(btn => {
        btn.addEventListener("click", function(e) {
            e.preventDefault();

            const imgUrl = this.getAttribute("data-img");
            modalImg.src = imgUrl;

            modal.classList.add("active");
        });
    });
    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            modal.style.display = "none";
        });
    }

    if (modal) {
    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            modal.classList.remove("active");
        }
    });
    }
});
